import { assign } from 'xstate5';

import type {
  InteractedStoreKind,
  LastInteractedStore,
  LastInteractedStoreAction,
  LastInteractedStoresEvent,
} from './LastInteractedStore.machine.types';

// ─── ACTIONS ────────────────────────────────────────────────────────────────────

export const setLastInteractedStore: LastInteractedStoreAction = assign(({ context }) => {
  const {
    activeCart: activeCartStore,
    menu: menuStore,
    lastPlacedOrder: lastPlacedOrderStore,
  } = context.interactedStores;

  return { lastInteractedStore: activeCartStore ?? menuStore ?? lastPlacedOrderStore };
});

export const setInteractedStore: LastInteractedStoreAction<{ storeKind: InteractedStoreKind }> =
  assign(({ context, event }, params) => ({
    interactedStores: {
      ...context.interactedStores,
      [params.storeKind]: getInteractedStore(event),
    },
  }));

export const resetInteractedStore: LastInteractedStoreAction<{ storeKind: InteractedStoreKind }> =
  assign(({ context }, params) => ({
    interactedStores: {
      ...context.interactedStores,
      [params.storeKind]: undefined,
    },
  }));

// ─── UTILS ──────────────────────────────────────────────────────────────────────

export const getInteractedStore = (event: LastInteractedStoresEvent): LastInteractedStore => {
  const lastInteractedStore = getInteractedStoreFromEvent(event);

  // return delivery address for delivery type stores
  if (lastInteractedStore?.addressId) {
    return {
      restaurantId: lastInteractedStore.restaurantId,
      restaurantName: lastInteractedStore.restaurantName,
      addressId: lastInteractedStore.addressId,
      deliveryFee: lastInteractedStore.deliveryFee,
      vendor: lastInteractedStore.vendor,
      vendorRestaurantId: lastInteractedStore.vendorRestaurantId,
    };
  }

  // return restaurant slug for pickup and outpost type stores
  if (lastInteractedStore?.restaurantSlug) {
    return {
      restaurantId: lastInteractedStore.restaurantId,
      restaurantName: lastInteractedStore.restaurantName,
      restaurantSlug: lastInteractedStore.restaurantSlug,
    };
  }

  return undefined; // to be explicit
};

export const getInteractedStoreFromEvent = (event: LastInteractedStoresEvent) => {
  const eventType = event.type;
  const isSetStoreEvent =
    eventType === 'SET_ACTIVE_CART_STORE' ||
    eventType === 'SET_LAST_INTERACTED_MENU_STORE' ||
    eventType === 'SET_LAST_PLACED_ORDER_STORE';

  if (!isSetStoreEvent) return;

  return event.store;
};
